import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "194fb0d9-212c-4cec-aa63-5bee43aa5235",
    content: "RT between 1.0 s and 1.5 s",
    options: {},
  },
  {
    id: "1f3a7749-2850-466c-9f51-86f34c418f2b",
    content: "RT between 0.5 s and 0.8 s",
    options: {},
  },
  {
    id: "b26de812-15a1-4ca9-9096-11eb4c6e99bb",
    content: "RT between 0.1 s and 0.3 s",
    options: {},
  },
];

export const task: Task = {
  id: "75b52a7e-a5ee-40fd-8e33-23aafb8a2251",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "order",
  data: ["1f3a7749-2850-466c-9f51-86f34c418f2b"],
};
